import { Card, Typography } from 'antd';
import type { ChartOptions } from 'chart.js';
import 'chart.js/auto';
import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';

const { Title, Text } = Typography;

interface FulfilmentRateProps {
    total: number;
    uncompletedBookings: number;
}

const FulfilmentRate: React.FC<FulfilmentRateProps> = ({ total, uncompletedBookings }) => {
    const completedBookings = total - uncompletedBookings;
    const fulfilmentRate = total > 0 ? ((completedBookings / total) * 100).toFixed(2) : 0;

    const chartData = useMemo(() => ({
        labels: ['Completados', 'No Completados'],
        datasets: [
            {
                label: 'Cantidad de Bookings',
                data: [completedBookings, uncompletedBookings],
                backgroundColor: [
                    'rgba(75, 192, 192, 0.6)',
                    'rgba(255, 99, 132, 0.6)',
                ],
                borderColor: [
                    'rgba(75, 192, 192, 1)',
                    'rgba(255, 99, 132, 1)',
                ],
                borderWidth: 2,
            },
        ],
    }), [completedBookings, uncompletedBookings]);

    const chartOptions = useMemo<ChartOptions<'bar'>>(() => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = context.parsed.y;
                        const percentage = total > 0 ? ((value / total) * 100).toFixed(2) : 0;
                        return `${context.label}: ${value} (${percentage}%)`;
                    },
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    precision: 0,
                },
            },
        },
    }), [total]);

    return (
        <Card bordered style={{ margin: '16px 0' }}>
            <Title level={4}>Tasa de Cumplimiento (Fulfilment Rate)</Title>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                <Text strong>
                    Total de Bookings:
                    {' '}
                    <Text type="secondary">{total + uncompletedBookings}</Text>
                </Text>
                <Text strong>
                    Tasa de Cumplimiento:
                    {' '}
                    <Text type={Number(fulfilmentRate) >= 80 ? 'success' : 'warning'}>
                        {fulfilmentRate}
                        %
                    </Text>
                </Text>
            </div>
            <div style={{
                height: 300, position: 'relative', width: '80%', margin: '0 auto',
            }}
            >
                <Bar data={chartData} options={chartOptions} />
            </div>
        </Card>
    );
};

export default FulfilmentRate;
